import { device_px, primary, secondary } from "@/styles/variable"
import styled from "styled-components"

const { MAX_767 } = device_px
export const SessionScheduleBtn = styled.button`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 5px;
  background-color: transparent;
  border: none;
  outline: none;
  cursor: pointer;
  color: ${primary.white};
  padding: 6px;
  border-bottom: 6px solid transparent;
  &.active {
    opacity: 1;
    color: ${secondary.text};
    border-bottom: 6px solid ${secondary.text};
  }
  @media screen and (max-width: ${MAX_767}) {
    padding: 3px;
    border-bottom: 3px solid transparent;
    white-space: nowrap;
    &.active {
      border-bottom: 3px solid ${secondary.text};
    }
  }
`

export const SessionScheduleBtnTitle = styled.span`
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: 150%;
  letter-spacing: -0.3px;
  @media screen and (max-width: ${MAX_767}) {
    font-size: 12px;
    line-height: 100%;
    text-align: left;
  }
`

export const SessionScheduleBtnDate = styled.span`
  width: 100%;
  font-size: 28px;
  font-style: normal;
  font-weight: 700;
  line-height: 140%;
  letter-spacing: -0.3px;
  @media screen and (max-width: ${MAX_767}) {
    font-size: 18px;
    line-height: 141%;
    text-align: left;
  }
`
